<h3 mat-dialog-title>Histórico de Ordens (BTG)</h3>
<div mat-dialog-content style="width: 100%">
    <!-- Tipo de Importação -->
    <div fxLayout="column" fxLayoutAlign="space-between">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Tipo Histórico</mat-label>
            <mat-select 
                placeholder="Tipo"
                [(value)]="model.tipo_historico" 
                [formControl]="tipo_historico"
                name="tipo_historico"
            >
                <mat-option value="">HISTÓRICO BTG</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerTipo"></mat-spinner>
        </mat-form-field>
    </div>

    <input hidden type="file" #fileInput (change)="uploadFile($event)" ng2FileSelect [uploader]="uploader" [accept]="['.xls','.xlsx']"/>
    <button mat-button (click)="fileInput.click()" tabindex="-1" [disabled]="uploader.queue.length > 0" >
        <mat-icon>cloud_upload</mat-icon>
        Importar Arquivo    
    </button>

    <p *ngFor="let item of uploader.queue">
        <b>{{nomeFile}}</b> 
        <button type="button" mat-button tabindex="-1" (click)="item.remove()">
            X
        </button>
    </p>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button 
        type="button"
        mat-button
        (click)="startUpload()"
        tabindex="-1" >
        Enviar
    </button>
</div>
